import React from 'react'
import * as S from './styles'
import Header from '../Header/Header'
import GlobalStyle from '../../assets/styles/GlobalStyle'
import IconSmartphone from '../../assets/imagens/icon-smartphone.png'

function MaintenanceView() {
  return (
    <S.Container>
      <GlobalStyle />
      <Header />
      <S.Card>
        <S.Title>
          Estamos em manutenção!
        </S.Title>
        <S.Image src={ IconSmartphone } />
        <S.Content>
          Pausa para melhorias no sistema para deixar a sua experiência ainda melhor. Tente novamente em alguns minutos.
        </S.Content>
      </S.Card>
    </S.Container>
  )
}

export { MaintenanceView }
